module.exports = __webpack_public_path__ + "static/media/28.39001ac0.jpg";